export default "__VITE_ASSET__CibAli2g__"